<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Admin Panel App
</script>

